import React, { useState, useEffect } from "react";
import { authenticationService } from "./../services";
import GoogleSSO from '../components/GoogleSSO/GoogleSSO';
import { MainLogo } from "../components/Page/MainPageStyles";

export const HomePath = "/";

function Home() {
  const [ loggedIn, setLoggedIn ] = useState(authenticationService.currentUserValue);

  useEffect(() => {
    authenticationService.currentUser.subscribe(x => {
      setLoggedIn(authenticationService.currentUserValue);
    });
  });

  if (loggedIn) {

    return (
      <div style={{height: '100%'}}>
        <div style={{height: '100%', padding: '20px', display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
          <div style={{display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center'}}>START NEW</div>
          <div style={{display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center'}}>History</div>
        </div>
      </div>
    );
  }

  return (
    <div style={{backgroundColor: "var(--color-white)", margin: "auto"}}>
      <GoogleSSO/>
    </div>
  );
}

export default Home;